<template>
  <div class="home">
    <a
      href="https://open.weixin.qq.com/connect/qrconnect?appid=wxd4d914a9a974b8ab&redirect_uri=http://blj.z2ww.com/&response_type=code&scope=snsapi_login&state=1111#wechat_redirect"
      >测试微信登录</a
    >

    <div id="login_container"></div>
  </div>
</template>
<style scoped>
.home{
  background-color: white;
}
</style>
<script>
import https from "../https.js";
export default {
  name: "",
  components: {},
  data() {
    return {};
  },
  created() {},
  mounted() {
    var obj = new WxLogin({
      self_redirect: true,
      id: "login_container",
      appid: "wxd4d914a9a974b8ab",
      scope: "snsapi_login",
      redirect_uri: "http://blj.z2ww.com/",
      state: "12313",
      style: "white",
      href: "",
    });
  },
  methods: {},
};
</script>
